import { AxiosResponse } from 'axios'
import { ProgramType } from '../components/dashboard/enums'
import { IWeekSchedule, IGeo } from '../reducers/programTypes'
// Starter character I refers to Interface

export type IReason = 'login' | 'update_password' | 'forget_password' | 'update_mobile' | 'update_email'

export interface ICreateOtpData {
  mobile?: string
  email?: string
  reason: string
}
export interface creatOtpResponse {
  data: string
}

export interface errorData {
  message: string
  errors: Record<string, any>
}

export interface creatOtpError {
  message: string
  code: string
  config: any
  name: string
  request: any
  response: {
    config: any
    data: string | errorData // string is for server error and errorData for bad request.
    headers: any
    request: any
    status: number
    statusText: string
  }
}

export interface IResponse<T = Record<string, unknown>> {
  data: T
  message: string
}

export interface PaginatedResponse<T = Record<string, unknown>, M = Record<string, unknown>> {
  data: T[]
  page: number
  total_count: number
  total_page: number
  has_next: boolean
  meta: M
  message: string
}

export type ISuccessCallback<T = AxiosResponse<IResponse<Record<string, any>>>> = (response: T) => void
export type IErrorCallback<T = creatOtpError> = (error: T) => void

export interface domainSearchParamsType {
  domain?: string
  page_size?: number
}

export interface IAuthWithOTPData {
  mobile?: string
  email?: string
  otp: string
  token?: string
}

export interface ILoginWithPasswordData {
  identity: string
  password: string
  token?: string
}

export interface IChangePasswordData {
  token: string
  password: string
}

export interface IUpdateUserInformationData {
  type: 'publisher' | 'advertiser' | 'admin'
}

export interface IRequestToken {
  email?: string
  mobile?: string
  otp: string
  reason: IReason
}

export interface IIdentityAttribute {
  attribute: 'email' | 'password' | 'mobile'
  existing_attribute_token?: string
  new_attribute_token: string
  value: string
}

export interface IUploadFile {
  file: any
  type: 'ad' | 'avatar' | 'national_id_card' | 'legal_documents'
}

export interface IUploadVideoFile {
  aparat_url: string
}

export interface IGetUploadedFile {
  type?: string
  title?: string
  sizes?: any
  page?: number
}

export interface IWithdrawData {
  amount: number
}

export interface IDepositData {
  amount: number
}

export interface ITransactionData {
  method?: string[]
  page?: number
  page_size?: number
  section?: 'advertiser' | 'publisher'
  from_created_at?: string
  to_created_at?: string
}

export interface getInvoicesTypes {
  page?: number
  page_size?: number
  start_date?: string
  end_date?: string
}

export interface getCurrentInvoicesTypes {
  gt?: Date | string
  gte?: Date | string
  lt?: Date | string
  lte?: Date | string
}

export interface retrieveInvoiceUrlParam {
  userId: string | undefined
  invoiceId: string | undefined
}

export interface ICreateCampaign {
  advertiser_domain: string
  budget: number
  description: string
  title: string
}

export interface IUpdateCampaign {
  advertiser_domain?: string
  budget?: number
  description?: string
  title?: string
}

export interface IHistogramData {
  gte?: string
  lt?: string
  periodically: string
  axis: string[]
  buy_type?: string
  filter?: string[]
  campaign_id?: string[]
  program_id?: string[]
  type?: ProgramType
  sort?: string
  page?: number
  page_size?: number
  aggregate_by_periodically?: boolean
  export_csv?: boolean
}
export interface IDashboardReportData {
  gte?: string
  lt?: string
  axis: string[]
  buy_type?: string
  filter?: string[]
  campaign_id?: string[]
  program_id?: string[]
  type?: ProgramType
  sort?: string
  page?: number
  page_size?: number
  country?: string
}

export interface ICampaignList {
  page?: number
  page_size?: number
  search?: string
  archived?: boolean | null
  status?: string[]
}

type ProgramOrderBy =
  | 'created_at'
  | 'modified-at'
  | 'start_date'
  | 'end_date'
  | '-created_at'
  | '-modified-at'
  | '-start_date'
  | '-end_date'

export interface IProgramList {
  archived?: number
  search?: number
  status?: string[]
  type?: string
  page_size?: number
  page?: number
  campaign_unique_id?: string[]
  exclude_rentals?: boolean
  order_by?: ProgramOrderBy[]
}

export interface IAdList {
  campaign_id?: string[]
  program_id?: string[]
  size?: string[]
  status?: string
  type?: string
  file?: string
  video?: string
  page_size?: number
}

export interface IAdCreate {
  file: string
  landing_url: string
  logo?: string
  palette?: string
  pause_banner?: string
  schema?: {
    button_title?: string
    caption?: string
    title?: string
  }
  title: string
  type: 'video' | 'native' | 'banner'
  video?: string
  view_tracker_url?: string
}
export interface IReportData {
  gte?: string
  lt?: string
  axis: string[]
  buy_type?: string
  filter?: string[]
  campaign_id?: Array<string | undefined>
  program_id?: Array<string | undefined>
  ad_id?: string[]
  type?: string
  sort?: string
  page?: number
  page_size?: number
  country?: string
  periodically?: string
  aggregated_by_periodically?: boolean
  export_csv?: boolean
}

export interface IUpdateProgram {
  exclude_categories?: string[]
  audience_ids?: string[]
  advertiser_domain?: string
  archivable?: boolean
  bid_price?: number
  budget?: number
  campaign?: object
  created_at?: string
  end_date?: Date | string
  geo?: IGeo[]
  exclude_geo?: IGeo[]
  include_categories?: string[]
  include_contents?: string[]
  isp?: string[]
  native_ads_count?: number
  policy?: string
  start_date?: Date | string
  status?: string
  title?: string
  type?: string
  unique_id?: string
  video_ads_count?: number
  include_websites?: string[]
  exclude_websites?: string[]
  include_website_collection_ids?: string[]
  exclude_website_collection_ids?: string[]
  include_keywords?: string[]
  exclude_keywords?: string[]
  inventories?: string[]
  device?: string[]
  week_schedule?: IWeekSchedule
  channels?: string[]
  frequency_capping?: number
  interfaces?: string[]
  barter?: boolean
  compensation?: boolean
}

export interface IEstimateProgram {
  exclude_categories?: string[]
  advertiser_domain?: string
  archivable?: boolean
  bid_price?: number
  budget: number
  end_date: Date | string
  include_categories?: string[]
  include_contents?: string[]
  isp?: string[]
  policy?: string
  start_date: Date | string
  type: string
  video_ads_count?: number
  include_websites?: string[]
  exclude_websites?: string[]
  include_keywords?: string[]
  exclude_keywords?: string[]
  inventories?: string[]
  device?: string[]
  channels?: string[]
  program_type_bid_floor: number
  geo: IGeo[]
  exclude_geo: IGeo[]
  include_website_collection_ids: string[]
  exclude_website_collection_ids: string[]
  frequency_capping: number
  compensation: boolean
  placement?: string[]
  interfaces?: string[]
  barter?: boolean
}

export const estimateProgram = [
  'exclude_categories',
  'bid_price',
  'budget',
  'end_date',
  'geo',
  'include_categories',
  'include_contents',
  'isp',
  'policy',
  'start_date',
  'type',
  'include_websites',
  'exclude_websites',
  'include_website_collection_ids',
  'exclude_website_collection_ids',
  'include_keywords',
  'exclude_keywords',
  'inventories',
  'device',
  'channels'
]

export interface IRetrieveTransactionsHistogramData {
  gte?: string
  lte?: string
  gt?: string
  lt?: string
}

export interface getFinancialReportParams {
  start_date: string
  end_date?: string
  page?: number
  page_size?: number
}

export interface campaignOverviewParams {
  campaign_id: string | undefined
  program_status?: string[]
  archived?: boolean
  gte?: Date
  gt?: Date
  lte?: Date
  lt?: Date
}

export interface IFinotechData {
  card_no: number
}

export interface IListBankDetailsData {
  page?: number
  page_size?: number
}

export interface IBankDetailData {
  bank_account_number: string
  bank_account_owner: string
  bank_card_number: string
  bank_iban: string
  bank_name: string
}

export enum NotificationOrder {
  NEWEST_FIRST = 'NEWEST_FIRST',
  OLDER_FIRST = 'OLDER_FIRST',
  READS_FIRST = 'READS_FIRST',
  READS_END = 'READS_END'
}

export enum NotificationCategory {
  FINANCIAL = 'FINANCIAL',
  SYSTEM_ADMINISTRATOR = 'SYSTEM_ADMINISTRATOR',
  OPERATION = 'OPERATION',
  MARKETING = 'MARKETING',
  EDUCATIONAL = 'EDUCATIONAL'
}

export interface IMessagesData {
  categories_unique_id?: string[]
  page?: number
  page_size?: number
  title?: string
  order?: NotificationOrder
  categories?: NotificationCategory
}

export interface IRetargetingList {
  page?: number
  page_size?: number
}

export interface ICreateCollections {
  name: string
  websites: string[]
}

export interface ICollectionsParams {
  userId: string | undefined
  collection_id: string
}

export interface IAudienceParams {
  unique_ids?: string[]
}

export interface ICollection {
  label_fa: string
  image: string
  username: string
  name: string
  title_en: string
  title_fa: string
  id: string
  uid: string
}

export interface IDomains {
  domain: string
  id: string
  image: string
  name: string
  type: string
}

export interface ICreateAdGroup {
  title: string
}

export interface suggestKeywordParams {
  keywords: string[]
  page_size?: number
  key_name?: string
  min_score?: number
  suggested_keyword?: string[]
}

export interface auditLogsUrlParam {
  userId: string | undefined
  auditLogId: string
  target: string
}

export interface auditLogsListUrlParam {
  userId: string | undefined
  campaignId: string | undefined
}

export interface filimoContentFilters {
  text?: string
  page_size?: number
  uid?: string
}

export interface auditLogsListFilters {
  target_type?: string[]
  page?: number
  programs_unique_id?: string[]
}

export interface IProgramResponse {
  exclude_keywords: any[]
  archivable: boolean
  placement: string[]
  start_date: Date
  end_date: Date
  status: string
  budget: number
  created_at: Date
  deletable: boolean
  include_website_collection_ids: any[]
  draft_reason: string
  rental: boolean
  unique_id: string
  os: any[]
  bid_price: number
  include_categories: any[]
  compensation: boolean
  channels: IChannel[]
  geo: any[]
  campaign: ICampaign
  audience_ids: any[]
  policy: string
  banner_ads_count: number
  frequency_capping: number
  video_ads_count: number
  isp: any[]
  device: any[]
  include_websites: string[]
  include_contents: IContent[]
  exclude_website_collection_ids: any[]
  exclude_categories: any[]
  barter: boolean
  interfaces: string[]
  targeted: boolean
  archived: boolean
  type: string
  include_keywords: string[]
  exclude_websites: any[]
  native_ads_count: number
  week_schedule: IWeekSchedule
  title: string
  inventories: string[]
  exclude_geo: any[]
  lease_details: {
    zones: {
      histogram: { date: string; available: number }[]
      website: string
      url: string
      title: string
      unique_id: string
      price: string
      percentage: string
      total_available: number
      active: boolean
    }[]
  }
}

export interface ICampaign {
  unique_id: string
  title: string
}

export interface IChannel {
  id: string
  label_fa?: string
}

export interface IContent {
  id: string
  label_fa?: string
}

export interface keywordEstimateParams {
  include_keyword: string[]
  exclude_keyword: string[]
}

export interface typeOverviewParams {
  archived?: number
  search?: number
  status?: string[]
}

export interface retableZonesParams {
  page?: string
  page_size?: string
  from_date: string | Date
  to_date: string | Date
  website_url: string
  title?: string
  rentable?: boolean
}
